interface Props {
  currentStep: number;     // 1-5 (Install, Login, Segurança, Push, Aprovado)
  totalSteps?: number;
  labels?: string[];
}

const DEFAULT_LABELS = ['Aplicativo', 'Identificação', 'Segurança', 'Notificações', 'Aprovado'];

/**
 * ProgressStepBar — Barra de progresso das Fases A-E do bonding mobile.
 * Exibe bolinhas numeradas com linha de conexão.
 *
 * Doc: docs_autentica_seguranca_hard/01-fluxo-mobile-biometria.md
 */
export function ProgressStepBar({ currentStep, totalSteps = 5, labels = DEFAULT_LABELS }: Props) {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <style>{`
        @keyframes active-step-pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(168, 85, 247, 0.6), inset 0 0 8px rgba(168, 85, 247, 0.2);
            transform: scale(1.05);
          }
          70% {
            box-shadow: 0 0 0 8px rgba(168, 85, 247, 0), inset 0 0 8px rgba(168, 85, 247, 0.2);
            transform: scale(1.12);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(168, 85, 247, 0), inset 0 0 8px rgba(168, 85, 247, 0.2);
            transform: scale(1.05);
          }
        }
        .active-step-indicator {
          animation: active-step-pulse 2s infinite ease-in-out;
        }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0 }}>
        {Array.from({ length: totalSteps }).map((_, i) => {
          const step = i + 1;
          const done = step < currentStep;
          const active = step === currentStep;
          return (
            <div key={step} style={{ display: 'flex', alignItems: 'center', flex: step < totalSteps ? 1 : 'none' }}>
              <div
                className={active ? 'active-step-indicator' : ''}
                style={{
                  width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '0.78rem', fontWeight: active ? 800 : 700,
                  background: done ? 'rgba(168, 85, 247, 0.2)' : active ? '#a855f7' : 'rgba(255,255,255,0.03)',
                  color: active ? '#ffffff' : done ? '#c084fc' : '#64748b',
                  border: active ? '2px solid #a855f7' : done ? '2px solid rgba(168, 85, 247, 0.4)' : '1px solid rgba(255,255,255,0.1)',
                  boxShadow: active ? undefined : 'none',
                  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                  transform: active ? undefined : 'scale(1)',
                }}
              >
                {done ? '✓' : step}
              </div>
              {step < totalSteps && (
                <div style={{
                  flex: 1, height: 2, margin: '0 6px',
                  background: done ? 'linear-gradient(90deg, rgba(168, 85, 247, 0.5), rgba(168, 85, 247, 0.2))' : 'rgba(255,255,255,0.05)',
                  transition: 'background 0.4s ease',
                  borderRadius: 2,
                }} />
              )}
            </div>
          );
        })}
      </div>
      {labels[currentStep - 1] && (
        <p style={{
          textAlign: 'center', fontSize: '0.78rem', color: '#94a3b8',
          marginTop: '0.5rem', fontWeight: 500,
        }}>
          Passo {currentStep} de {totalSteps} — {labels[currentStep - 1]}
        </p>
      )}
    </div>
  );
}
